import React from "react";
import '../index.css';
import Navbar from "./navbar";
import Footer from "./footer";
import Features from "./home_components/Features";
import SmolBanner from "./home_components/SmolBanner";
import "../css/cart.css";
import "../css/top_banner.css";
import axios from "axios";
import baseUrl from "../base_url";
import Loader from "./home_components/loader";
import { Link } from "react-router-dom";
import CartSkeletonLoader from "./components/cartSkeleton.jsx"
import ErrorComponent from "./components/ErrorComponent.jsx";

import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';


function MainContentBanner(props) {
    const styles = {
        width: "100%",
        minWidth: "100%",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: 500,
    };

    return (
        <div style={styles} className="MainContentBanner">
            <p>HM.com / View All / <span style={{ color: "red", fontSize: "15px", paddingLeft: "5px", fontWeight: "600" }} className="red">Cart</span> </p>
        </div>
    );
}

function CartLeft(props) {
    return (
        <div className="cart_info_left">
            {props.items.map((item) => (
                <ProductInCart
                    key={item._id}
                    name={item.title}
                    price={item.price}
                    img={item.image}
                    productId={item.productId}
                    size={item.size}
                    setCart={props.setCart}
                    setItem={props.setItem}
                    cart={props.cart}
                    quantity={item.quantity}
                    slug={item.slug}
                    inventory={item.inventory}
                    updateTotalPrice={props.updateTotalPrice}
                />
            ))}
        </div>
    );
}

const PriceBreakUp = ({ items }) => {
  return (
    <div className="w-full rounded-lg ">
      <div className="flex justify-between border-b mb-2 font-semibold text-[15px]">
        <p className="text-[14px]">Price × Quantity</p>
        <p className="text-[14px]">Total</p>
      </div>

      {/* Price List */}
      {items.map((item, index) => {
        const { price, quantity } = item;
        const cartValue = price * quantity;

        return (
          <div key={index} className="flex justify-between py-1 last:border-none ">
            <p className="text-[14px]">{price} × {quantity}</p>
            <p className="text-[14px]">Rs. {cartValue}</p>
          </div>
        );
      })}
    </div>
  );
};


function CartRight({ totalPrice, items }) {
    return (
        <div className="cart_info_right">
            <div className="proceed">
                <div className="proceed_abv ">

                    <PriceBreakUp
                        items={items}
                    />

                    <span className="pt-[10px] border-t">
                        <p>Total Order value</p>
                        <p>Rs. {totalPrice}</p>
                    </span>
                    <span>
                        <p>Delivery</p>
                        <p>FREE</p>
                    </span>
                </div>
                <div className="proceed_btm">
                    <span>
                        <p>Total</p>
                        <p>Rs. {totalPrice}</p>
                    </span>
                    <a href={`/checkout`}> Continue to checkout </a>
                </div>
                <div className="checkout_info">
                    <p>We accept all payment methods via RazorPay</p>
                    <div className="payment_infos">
                        {/* Payment icons */}
                    </div>
                    <p className="disclaimer_p">Prices and delivery costs are not confirmed until you've reached the checkout.
                        15 days free returns. Read more about return and refund policy.
                        Customers would receive an SMS/WhatsApp notification regarding deliveries on the registered phone number.</p>
                </div>
            </div>
        </div>
    );
}

function ProductInCart(props) {

    const [inventory, setInventory] = React.useState(props.inventory || 10)
    const [deleteLoading, setDeleteLoading] = React.useState(false)
    const [quantity, setQuantity] = React.useState(props.quantity);

    React.useEffect(() => {
        async function fetchInventory(id) {
            try {
                const response = await axios.get(`${baseUrl}api/products/data/inventory/${id}`)
                setInventory(response?.data?.data?.inventory)
            } catch (err) {
                console.log("error while fetching inventory")
                console.log(err)
            }
        }
        fetchInventory(props.productId)
    }, [props.productId])


    async function handleDelete(productId) {
        setDeleteLoading(true)
        try {
            const accessToken = localStorage.getItem("accessToken")
            await axios.post(
                `${baseUrl}api/cart/remove/${productId}`,
                {}, 
                {
                    withCredentials: true,
                    headers: {
                    Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json', 
                    },
                }
            )

            const updatedCart = props.cart.filter(item => item.productId !== productId);
            props.setCart(updatedCart);
            props.setItem(updatedCart);
            
            // Update total price after removing item
            props.updateTotalPrice(updatedCart);
        } catch (error) {
            console.error("Error removing item from cart:", error.response?.data || error.message);
        } finally {
            setDeleteLoading(false);
        }
    }

    const handleQuantityChange = async (event) => {
        const selectedQuantity = parseInt(event.target.value);
        setQuantity(selectedQuantity);

        try {
            const accessToken = localStorage.getItem("accessToken");

            await axios.post(
            `${baseUrl}api/cart/quantity/${props.productId}`,
            {
                quantity: selectedQuantity,
            },
            {
                withCredentials: true,
                headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', // optional but recommended
                },
            }
            );

            // Update the cart with the new quantity
            const updatedCart = props.cart.map(item => {
                if (item.productId === props.productId) {
                    return { ...item, quantity: selectedQuantity };
                }
                return item;
            });
            
            props.setCart(updatedCart);
            props.setItem(updatedCart);
            
            // Update total price after changing quantity
            props.updateTotalPrice(updatedCart);
            
        } catch (error) {
            console.error("Error updating quantity:", error.response?.data || error.message);
        }
    };
    
    return (
        <div className="CartProduct shadow-lg h-auto">
            <div className="CartProductLeft">
                <img width={"120px"} src={props.img} alt="" />
            </div>
            <div className="CartProductRight">
                <span className="abcdfe">
                    <a className="text-wrap mr-4" href={`/productpage/${props.productId}`}>{props.name}</a>
                    <button onClick={() => handleDelete(props.productId)}>
                        {!deleteLoading && <i className="px-[10px] fa-duotone fa-solid fa-trash"></i>}
                        {deleteLoading && <div className="Loading_Area"> <Loader /></div>}
                    </button>
                </span>
                <p className="price_p">Rs. {props.price}</p>
                <p className="smol_p_cart"><span className="fixed_width">Art.no.</span><span className="pad_right">{props.productId}</span></p>
                <p className="smol_p_cart"><span className="fixed_width">Total: </span> <span className="pad_right">Rs. {props.price * quantity}</span></p>
                {/* <p className="smol_p_cart"><span className="fixed_width">Size: </span> <span className="pad_right">{props.size}</span></p> */}
                <div className="Cart_buttons_Area  !pt-3">
                    {/* <button className="Favt"><i className="fa-light fa-heart"></i></button> */}
                    {/* <select
                        className="quantity flex items-center justify-center text-center"
                        value={quantity}
                        onChange={handleQuantityChange}
                    >
                        {Array.from({ length: Math.min(inventory, 5) }).map((_, index) => (
                            <option key={index} value={index + 1}>{index + 1}</option>
                        ))}
                    </select> */}
                    <Box sx={{ minWidth: 40 , maxHeight : 20 }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Qty</InputLabel>
                            <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={quantity}
                            label="Age"
                            onChange={handleQuantityChange}
                            >
                            {Array.from({ length: Math.min(inventory, 5) }).map((_, index) => (
                                <MenuItem key={index} value={index + 1}>{index + 1}</MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                    </Box>
                </div>
            </div>
        </div>
    );
}

function CenteredDiv() {
    const [cart, setCart] = React.useState([]);
    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [totalPrice, setTotalPrice] = React.useState(0);

    // Function to calculate total price from cart items
    const calculateTotalPrice = (cartItems) => {
        return cartItems.reduce((total, item) => {
            return total + (item.price * item.quantity);
        }, 0);
    };

    // Function to update total price
    const updateTotalPrice = (cartItems) => {
        const newTotal = calculateTotalPrice(cartItems);
        setTotalPrice(newTotal);
    };

    React.useEffect(() => {
        async function fetchCart() {
            try {
                const accessToken = localStorage.getItem("accessToken");

                const response = await axios.get(`${baseUrl}api/cart/get-cart`, {
                withCredentials: true,
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json', // optional but recommended
                    },
                });

                const cartData = response.data.data.cart;
                
                setCart(cartData);
                setItems(cartData);
                
                // Either use the server-provided total or calculate it
                if (response.data.data.value) {
                    setTotalPrice(response.data.data.value);
                } else {
                    setTotalPrice(calculateTotalPrice(cartData));
                }
                
                setLoading(false);
            } catch (error) {
                console.error("Error fetching cart data:", error);
                setLoading(false);
            }
        }

        fetchCart();
    }, []);


    return (
        <div className="cart_page h-[100%] flex flex-col items-center flex-1 flex-grow ">
            <div className="centedDivCart  flex flex-grow">
                <h1 className="mb-[40px] pt-[20px] pb-[30px] text-xl md:text-3xl">Shopping bag</h1>
                
                {/* Show skeleton loader while loading */}
                {loading && <CartSkeletonLoader />}
                
                {/* Show cart items when loaded and not empty */}
                {!loading && items.length >= 1 && (
                    <div className="Cart_info mt-[50px] ">
                        <CartLeft 
                            items={items} 
                            setItem={setItems} 
                            setCart={setCart} 
                            cart={cart} 
                            updateTotalPrice={updateTotalPrice} 
                        />
                        <CartRight totalPrice={totalPrice} items={items} />
                    </div>
                )}
                
                {/* Show empty cart message when loaded but empty */}
                {!loading && items.length === 0 && (
                    <ErrorComponent
                        error = {false}
                        message="Your cart is empty"
                        desc = "Browse our products and add items to your cart to proceed with checkout."
                        button = "Shop Now"
                        href ="/store/products"
                    />                    
                )}  
            </div>
        </div>
    );
}

function CartPage() {
    React.useEffect(() => {
        document.title = "Jutexx | Shopping Bag";
    }, []);
    return (
        <div className="home_page min-h-screen flex flex-col">
            <Navbar />
            {/* <MainContentBanner /> */}
            {/* <Features /> */}
            <CenteredDiv />
            <Footer />
        </div>
    );
}

export {CartPage, ProductInCart};